module.exports = __webpack_public_path__ + "img/lachskaviarsushioben.1371ca50.png";